import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';

const getters: GetterTree<RootState, RootState> = {
    getErrMessage: (state: RootState) => {
        return state.errMessage;
    },
    getInfoMessage: (state: RootState) => {
        return state.infoMessage;
    },
    isLoading: (state: RootState) => {
        return state.isLoading;
    }
};

export default getters;